const handleNoPrismicData = () => {
    // If we're not previewing and there's no content then something's gone wrong so we should stop the build
    if (!process.env.GATSBY_PRISMIC_PREVIEWS) {
        throw new Error('No Prismic content')
    }

    return null
}

export default handleNoPrismicData
